<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table no-provider-paging responsive id="my-table" :items="tableData"
             :per-page="perPage"
             :current-page="currentPage"
             tbody-tr-class="test"
             :fields="fields" v-on:row-clicked="rowClicked"
             :sort-by="sortBy"
             :sort-desc="sortDesc"
             sort-icon-left
             class="custom-auto-height">
      <template #table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: calcSize(field.key) }"
        />
      </template>
      <template v-slot:cell(ziel_datum)="data">
        <div v-if="isOlder(data.item.ziel_datum)" style="color: red"><b>{{data.value}}</b></div>
        <div v-else>{{data.value}}</div>
      </template>
      <template v-slot:cell(auf_stat)="data">
        <overdue-icon
            v-if="getZielStatus(data.item.ziel_datum) === 'overdue'"
            title=""
            v-tooltip="'Überfällig'"
            class="icon-1_5x" fillColor="#383838" style="color: red" :size="72" ></overdue-icon>
        <circle-day-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'today'"
            title=""
            v-tooltip="'Heute'"
            class="icon-1_5x" fillColor="#383838" style="color: red" :size="72" ></circle-day-icon>
        <circle-week-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'week'"
            title=""
            v-tooltip="'Eine Woche'"
            class="icon-1_5x" fillColor="#383838" style="color: orange" :size="72" ></circle-week-icon>
        <circle-month-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'month'"
            title=""
            v-tooltip="'Ein Monat'"
            class="icon-1_5x" fillColor="#383838" style="color: green" :size="72" ></circle-month-icon>
        <circle-half-year-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'halfYear'"
            title=""
            v-tooltip="'Ein halbes Jahr'"
            class="icon-1_5x" fillColor="#383838" style="color: #008080" :size="72" ></circle-half-year-icon>
        <circle-year-icon
            v-else-if="data.item.ziel_datum !== null"
            title=""
            v-tooltip="'Ein Jahr'"
            class="icon-1_5x" fillColor="#383838" style="color: #004680" :size="72" ></circle-year-icon>
      </template>
      <template v-slot:cell(count_open)="data">
        <checkmark
            v-if="data.item.count_open > 0 || data.item.count_finished > 0 || data.art === 'G'"
            title=""
            v-tooltip="'Vergeben'"
            class="icon-1_5x icon-def-green" fillColor="#383838" :size="72" ></checkmark>
        <div v-else></div>
      </template>
      <template v-slot:cell(completed)="data">
        <div style="display: flex;
    flex-direction: row;" v-if="data.item.count_open > 0 || data.item.count_finished > 0 || data.item.modul === 'G'" >
          <checkmark
              v-if="data.item.complete === 1"
              title=""
              v-tooltip="'Fertig'"
              class="icon-1_5x" style="color: #027a02" fillColor="#027a02" :size="72"></checkmark>
          <span  v-if="data.modul === 'LS'" :style="data.item.count_finished === data.item.count_open + data.item.count_finished ? 'padding-top: 6px; margin-left: 3px; color: green;' : 'padding-top: 6px; margin-left: 3px'"><b>{{data.item.count_finished}}/{{data.item.count_open + data.item.count_finished}}</b></span>
          <span  v-else :style="data.item.complete === 1 ? 'padding-top: 6px; margin-left: 3px; color: green;' : 'padding-top: 6px; margin-left: 3px'"><b>{{data.item.complete === 1 ? '1/1' : '0/1'}}</b></span>
        </div>
        <div v-else>
          <checkmark
              v-if="data.item.complete === 1"
              title=""
              v-tooltip="'Fertig'"
              class="icon-1_5x" style="margin-top: -1px; color: green" fillColor="#383838" :size="72"></checkmark>
        </div>
      </template>
      <template #row-details="data">
        <div @click="rowClicked(data.item, data.index, $event)" style="padding: 0.15rem 0.75rem !important; margin-top: -10px">
          <span class="message-memo" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: block; max-width: 40vw;">{{data.item.description}}</span>
        </div>
      </template>
    </b-table>
    <div class="mt-3 custom-flex-0">
      <b-pagination v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"

                    aria-controls="my-table" align="center"></b-pagination>
    </div>
  </b-card>
</template>

<script>
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import CurrencyEurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
import CircleYearIcon from 'vue-material-design-icons/CircleOutline.vue'
import CircleHalfYearIcon from 'vue-material-design-icons/CircleSlice2.vue'
import CircleMonthIcon from 'vue-material-design-icons/CircleSlice4.vue'
import CircleWeekIcon from 'vue-material-design-icons/CircleSlice6.vue'
import CircleDayIcon from 'vue-material-design-icons/CircleSlice7.vue'
import OverdueIcon from 'vue-material-design-icons/BellCircleOutline.vue'
import {Server_URL, Server_URL_MAENGELMELDER} from "../../shared/utils";
import {decryptAES, decryptFile} from "../../shared/crypto";
import HasAttachment from 'vue-material-design-icons/Attachment.vue';
import Checkmark from 'vue-material-design-icons/Check.vue';
import Alert from 'vue-material-design-icons/AlertCircleOutline.vue';
import MapIcon from 'vue-material-design-icons/Map.vue';
import ChatIcon from 'vue-material-design-icons/Chat.vue';
import InfoIcon from 'vue-material-design-icons/InformationOutline.vue';
import VueContext from 'vue-context';




export default {
  name: 'TourExecutionTable',
  components: {
    BookOpenPageVariantIcon, CheckBoldIcon, CurrencyEurIcon, CloseCircleIcon,
    HasAttachment, Checkmark, Alert, MapIcon, VueContext,
    CircleYearIcon, CircleHalfYearIcon, CircleMonthIcon, CircleWeekIcon,
    CircleDayIcon, OverdueIcon, ChatIcon, InfoIcon
  },
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
    rowClickCallback: {
      type: Function,
      default: undefined
    },
    allGroups: {
      default: {}
    },
  },
  data: () => {
    return {
      sortBy: 'quittung_datum',
      sortDesc: true,
      fields: [
        {key: 'auftrag_wo', label: "Betreff", sortable: true},
        {key: 'quittung_datum', label: "Anlage", formatter: "dateToString", sortable: true},
        {key: 'datum', label: "Eingang", formatter: "dateToString", sortable: true},
        {key: 'ziel_datum', label: "Ziel", formatter: "dateToString", sortable: true},
        {key: 'auf_stat', label: ""},
        {key: 'count_open', label: 'Verg.'},
        {key: 'completed', label: 'Erledigt'},
        {key: 'sachbearbeiter', label: 'Absender', formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            if (item.modul === 'G') {
              return "Tagesbericht";
            }
            if (item.modul === "mm") {
              return "Mängelmelder"
            } else if (item.modul === "bk") {
              return "Baumkontrolle";
            } else if (item.modul === "k1") {
              return "Spielplatzkontrolle";
            } else if (item.modul === "k2" || item.modul === "k4") {
              return "GPS-Nachweis";
            } else if (item.modul === "k3") {
              return "Straßenkontrolle";
            } else if (item.modul === "k5" || item.modul === 'ft') {
              return "Fast-Task";
            }
            let res = JSON.parse(sessionStorage.getItem(item.sachbearbeiter));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }, sortable: true, sortByFormatted: true},

      ],
      currentPage: 1,
      perPage: 20,
      url: Server_URL,
      currentClicked: null,
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.$emit('page-changed', newValue);
    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
  },
  methods: {
    calcSize(field) {
      if (field === 'selected') {
        return '36px';
      } else {
        return 'initial';
      }
    },
    rowClicked(item, index, target) {
      this.$router.push("/auftraege/auftrag/"+item.id);

      if (this.rowClickCallback !== undefined) {
        this.rowClickCallback(item, index);
      }
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    isOlder(value) {
      if (value === null) {
        return false;
      }
      let valueDate = new Date(value.replace('Z',''));
      valueDate.setHours(0, 0, 0, 0)
      let cur = new Date();
      cur.setHours(0, 0, 0, 0)
      return valueDate.getTime() < cur.getTime();
    },
    getZielStatus(ziel) {
      if (ziel === null) {
        return "noDueDate";
      }
      const now = new Date();
      now.setHours(0, 0, 0, 0)
      const dueDate = new Date(ziel.replace('Z',''));
      dueDate.setHours(0, 0, 0, 0)
      const timeDifference = dueDate - now;
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

      if (daysDifference < 0) {
        return "overdue";
      } else if (daysDifference === 0) {
        return "today";
      } else if (daysDifference <= 7) {
        return "week";
      } else if (daysDifference <= 30) {
        return "month";
      } else if (daysDifference <= 182) {
        return "halfYear";
      } else  {
        return "year";
      }
    },
    formateMemo(value) {
      if (value === null) {
        return "";
      }
      if (value.length > 80)
        return value.substring(0,80) + '...';
      else
        return value;
    },
    formateMoney(value) {
      if (value === null) {
        return "";
      }
      return ""+value+" €"
    },
    formateAuftragnehmer(value, key, item) {
      if (item === null) {
        return null;
      }

      let res = JSON.parse(sessionStorage.getItem(value));
      if (res === null) {
        if(value in this.allGroups) {
          return this.allGroups[value]
        }

        return value;
      }
      return res.first_name + " " + res.surname;
    },
    formateTeilaufgaben(value, key, item) {
      if (item === null) {
        return null;
      }
      let ges = item.number_open + item.number_finished;
      if (ges === 0) {
        return "keine";
      } else {
        return ""+ item.number_finished + "/" + ges;
      }
    },
    responseError(response) {
      console.log(response)
    },
    changePage(page) {
      if (page !== this.currentPage && ((page - 1) * this.perPage) < this.rows) {
        this.currentPage = page;
      }
    }
  }
}
</script>

<style scoped>

.h-1px {
  height: 1px;
}

.icon-def-grey {
  color: #5f6368;
}

.icon-def-green {
  color: green;
}

::v-deep .table td {
  padding: 0.15rem 0.75rem !important;
}

::v-deep table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
  padding: 0px !important;
}

::v-deep .table.b-table>thead>tr>th[aria-sort]:before {
  float: none !important;
  margin-left: 0 !important;
  margin-right: 0.5em !important;
  font-size: larger;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="ascending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table.b-table>thead>tr>th[aria-sort="descending"] {
  border: 2px solid #c8ced3;;
}

::v-deep .table thead th {
  white-space: nowrap;
}

.message-subject {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  line-height: 30px;
  font-weight: normal;
  color: #202124;
  vertical-align: sub;
}

.message-body {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #383838;
  font-weight: normal;
  vertical-align: sub;
}

.message-memo {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #5f6368;
  font-weight: normal;
  vertical-align: sub;
}
</style>

